import React from "react";
import QRCode from "qrcode.react";
import useDroneStore from "../../../store/droneStore";

const GenerateQRCode = ({ name, data }) => {

    const { setShowDroneQrCode } = useDroneStore((state) => state)

    const downloadQR = () => {
        const canvas = document.getElementById("123456");
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "123456.png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    console.log(data)
    const formattedDataToString = JSON.stringify(data)
    return (
        <div className="grid place-items-center w-screen h-screen fixed z-50 bg-black/25 backdrop-blur-sm inset-0">
            <div id="defaultModal" className="p-4 overflow-x-hidden overflow-y-auto md:inset-0">
                <div className="relative w-full max-w-xl max-h-fit">
                    <div className="relative bg-white rounded-lg dark:bg-white"
                    >
                        <div className="flex items-start justify-between p-4 rounded-t dark:border-gray-600">

                            <span>
                                <h3 className="text-3xl font-semibold text-gray-900 dark:text-black capitalize">
                                    {name}
                                </h3>
                            </span>
                            <button
                                onClick={() => { setShowDroneQrCode(false) }}
                                type="button" className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-red-500 dark:hover:text-white" data-modal-hide="defaultModal">
                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="text-center">
                            <QRCode
                                id="123456"
                                value={formattedDataToString}
                                size={290}
                                level={"H"}
                                includeMargin={true}
                            />
                            <a onClick={downloadQR} className="cursor-pointer"> Download QR </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GenerateQRCode;
